var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],attrs:{"id":"loading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }